module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "error-page"
  }, [_c('h2', {
    staticClass: "headline text-yellow"
  }, [_vm._v(" 404")]), _vm._v(" "), _c('div', {
    staticClass: "error-content"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n                    We could not find the page you were looking for.\n                    Meanwhile, you may "), _c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("return to dashboard")]), _vm._v(" or try using the search form.\n                ")], 1), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n            404 Error Page\n        ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("404 error")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-warning text-yellow"
  }), _vm._v(" Oops! Page not found.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "submit",
      "name": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25d723ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/404.vue
// module id = 1888
// module chunks = 1